/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createRestrictionsRepository = (options: RestApiOptions): Types.RestrictionsRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/restrictions/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
